export default "/img/icon/flag_large.svg"